import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

const toNonNegativeInt = (n) => {
  const num = Number(n);
  if (!Number.isFinite(num)) return 0;
  return Math.max(0, Math.trunc(num));
};

/**
 * Transforms shared_count criteria for Social Media Engagement.
 * Legacy hides list items with 0/null values.
 *
 * @param {Object} sharedCountCriteria - criteria.shared_count
 * @returns {Object} transformed criteria
 */
export const transformSharedCount = (sharedCountCriteria) => {
  if (!sharedCountCriteria) {
    return {
      status: 'error',
      iconType: 'error',
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No Social Media Engagement were found.',
      data: null,
    };
  }

  const wooRankStatus = sharedCountCriteria?.status || 'neutral';
  const importance = sharedCountCriteria?.importance || 0;
  const solvability = sharedCountCriteria?.solvability || 0;

  const facebookShares = toNonNegativeInt(sharedCountCriteria?.data?.facebookShares);
  const facebookComments = toNonNegativeInt(sharedCountCriteria?.data?.facebookComments);
  const facebookReactions = toNonNegativeInt(sharedCountCriteria?.data?.facebookReactions);
  const pinterest = toNonNegativeInt(sharedCountCriteria?.data?.pinterest);

  const isEmpty = facebookShares === 0
    && facebookComments === 0
    && facebookReactions === 0
    && pinterest === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: isEmpty ? 'No Social Media Engagement were found.' : null,
    data: isEmpty
      ? null
      : {
          facebookShares,
          facebookComments,
          facebookReactions,
          pinterest,
        },
  };
};

export default transformSharedCount;


